import { Tokens } from "../Interfaces/Interfaces";
import { API } from "../APIs/index";
import { TokenValidator } from "./TokenValidator";
export class FloatFinanceService {

    tokens: any | Tokens;
    get = API.agentLoanRequest + 'get/agentLoanRequest/';
    post = API.agentLoanRequest + 'post/agentLoanRequest/';
    delete = API.agentLoanRequest + 'delete/agentLoanRequest/';
    put = API.agentLoanRequest + 'put/agentLoanRequest/';

    constructor() {
        this.tokens = TokenValidator();
    }

    async floatFinanceTable(data: any) {

        try {
            let response = await fetch(this.get + `aggregator/count/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.tokens.access_token}`,
                    'x-api-key': `${process.env.REACT_APP_API_KEY}`
                }
            });

            return await response.json();
        } catch (err) {
            throw err;
        }

    }
    floatFinanceService() {

        return [{
            agentId: "0810869594",
            agentName: "Prosper Joshua",
            type: "Float",
            amount: 5000,
            status: "Repaid",
            isRecommended: true
        },
        {
            agentId: "0810869594",
            agentName: "Prosper Joshua",
            type: "Float",
            amount: 5000,
            status: "Declined",
            isRecommended: false
        },
        {
            agentId: "0810869594",
            agentName: "Prosper Joshua",
            type: "Float",
            amount: 5000,
            status: "Pending",
            isRecommended: false
        },
        {
            agentId: "0810869594",
            agentName: "Prosper Joshua",
            type: "Float",
            amount: 5000,
            status: "Behind",
            isRecommended: true
        },
        {
            agentId: "0810869594",
            agentName: "Prosper Joshua",
            type: "Float",
            amount: 5000,
            status: "Approved",
            isRecommended: true
        }]

        // try {
        //   let response = await fetch(this.transaction + `transaction/getcoordinatordashboard`, {
        //     method: 'GET',
        //     headers: {
        //       'Content-Type': 'application/json',
        //       'Authorization': `Bearer ${this.tokens.access_token}`,
        //       'x-api-key': `${process.env.REACT_APP_API_KEY}`
        //     },
        //   });

        //   return await response.json();
        // } catch (err) {
        //   throw err;
        // }
    }
    async requestDashboardFloat(whereCondition: any) {
        try {
            let response = await fetch(this.get + `aggregator/dashboard/${whereCondition}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.tokens.access_token}`,
                    'x-api-key': `${process.env.REACT_APP_API_KEY}`
                },
            });

            return await response.json();
        } catch (err) {
            throw err;
        }
    }
    async recommendAndDeclinedServices(data: any) {
        if (data.statusSubmit === "Recommend") {
            let recData = {
                requestId: data.requestId,
                transactionPin: data.transactionPin.otp,

            }
            try {
                let response = await fetch(this.post + 'RecommendAgentForLoan', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.tokens.access_token}`,
                        'x-api-key': `${process.env.REACT_APP_API_KEY}`
                    },
                    body: JSON.stringify(recData),
                });

                return await response.json();
            } catch (err) {
                throw err;
            }
        } else {
            let dataDec = {
                reason: data.reason,
                requestId: data.requestId,
                transactionPin: data.transactionPin.otp,

            }
            try {
                let response = await fetch(this.put + 'Aggregator/DeclineLoan', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.tokens.access_token}`,
                        'x-api-key': `${process.env.REACT_APP_API_KEY}`
                    },
                    body: JSON.stringify(dataDec),
                });

                return await response.json();
            } catch (err) {
                throw err;
            }
        }

    }

    async confirmPaymentServices(data: any) {
        if (data.statusSubmit === "Cash Repayment") {
            let recData = {
                requestId: data.requestId,
                transactionPin: data.transactionPin,
                paymentMode: data.paymentMode

            }
            try {
                let response = await fetch(this.post + 'ConfirmRepayment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.tokens.access_token}`,
                        'x-api-key': `${process.env.REACT_APP_API_KEY}`
                    },
                    body: JSON.stringify(recData),
                });

                return await response.json();
            } catch (err) {
                throw err;
            }
        } else {
            let dataDec = {

                requestId: data.requestId,
                transactionPin: data.transactionPin,
                paymentMode: data.paymentMode
            }
            try {
                let response = await fetch(this.post + 'ConfirmRepayment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.tokens.access_token}`,
                        'x-api-key': `${process.env.REACT_APP_API_KEY}`
                    },
                    body: JSON.stringify(dataDec),
                });

                return await response.json();
            } catch (err) {
                throw err;
            }
        }

    }

    async remindAgentServices(data: any) {
        let recId = {
            requestId: data
        }
        try {
            let response = await fetch(this.post + 'RemindAgent', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.tokens.access_token}`,
                    'x-api-key': `${process.env.REACT_APP_API_KEY}`
                },
                body: JSON.stringify(recId),
            });

            return await response.json();
        } catch (err) {
            throw err;
        }

    }

    async getFloatFinanceDetailsById(data: any) {
        try {
            let response = await fetch(this.get + `GetDetails/${data}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.tokens.access_token}`,
                    'x-api-key': `${process.env.REACT_APP_API_KEY}`
                }
            });

            return await response.json();
        } catch (err) {
            throw err;
        }

    }
    floatActionFilterDaysServices = (data: any) => {
        const fetchRecByDate = [{
            title: "REQUESTS", days: [
                { id: "1", day: 350, title: "REQUESTS" },
                { id: "2", day: 200, title: "REQUESTS" },
                { id: "3", day: 600, title: "REQUESTS" }
            ]
        }, {
            title: "APPROVED", days: [
                { id: "1", day: 30, title: "APPROVED" },
                { id: "2", day: 270, title: "APPROVED" },
                { id: "3", day: 200, title: "APPROVED" }
            ]
        },
        {
            title: "DEFAULTS", days:
                [{ id: "1", day: 302, title: "DEFAULTS" }, { id: "2", day: 470, title: "DEFAULTS" },
                { id: "3", day: 100, title: "DEFAULTS" }],


        }

        ]
        const filterRecord = fetchRecByDate.find(record => record.title === data.title);
        if (filterRecord) {

            return filterRecord.days.find(days => days.id === data.id)
        }

    }
}